/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import axios from "axios";
import Select from "react-select";
import { apiUrl, adminlimit, clientheaderconfig } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import {
  showStatus,
  encodeValue,
  removeItem,
  showLoader,
  hideLoader,
  showRecords
} from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "products";
var moduleName = "Vouchers";
var qs = require("qs");
class List extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    this.state = {
      companyID: companyID,
      path: this.props?.location?.pathname || '',
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      loading: true,
      name: "",
      status: "",
      storeID: "",
      producttype: "",
      outletList: [],
      listoutlet:[],
      searchKeyWord: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadList(1);
    this.loadOutlet();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listoutlet:nextProps.listoutlet,
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  loadOutlet() {
    var urlShringTxt =
      apiUrl +
      "outlet/dropdown?company_id=" +
      this.state.companyID;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ outletList: res.data.result });
      }
    }).catch();
  }

  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  removeItem(deleteID) {
    removeItem(deleteID, module, 'client', this.sateValChange, this.state.currentPage);
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value }, function () {});
  }

  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (
      this.state.storeID !== null &&
      Object.keys(this.state.storeID).length > 0
    ) {
      addParams += "&storeID=" + this.state.storeID.value;
    }
    if (
      this.state.status !== null &&
      Object.keys(this.state.status).length > 0
    ) {
      addParams += "&status=" + this.state.status.value;
    }
    var producttype = this.state.producttype?.value || '';
    if (producttype!=="") {
      addParams += "&producttype=" + producttype;
    }
    
    var params = {
      params:
        "limit=" +
        adminlimit +
        "&offset=" +
        offset+
        addParams,
      url: apiUrl + module,
      authType: "client",
    };
    this.props.getListData(params);
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        storeID: "",
        producttype: "",
        status: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }
  getAIData() {
    showLoader('searchAI')
    var postObject = {
      searchKeyWord: this.state.searchKeyWord,
    };
    axios
      .post(
        apiUrl + "products/getAIData",
        qs.stringify(postObject),
        clientheaderconfig
      )
      .then((res) => {
        hideLoader("searchAI");
        if (res.data.status === "ok") {
          var voucherData = {
            title:res.data.title,
            description:res.data.description
          }
          this.props.navigate("/clientpanel/catalog-products/add", {
            state: voucherData,
          });
        }
      });
  }

  displayOutlet(storedOutletID) {
    if(storedOutletID!=="") {
      var splitstoredOutletID = storedOutletID.split(',');
      var dipslyOutlet = [];
      if(this.state.listoutlet.length>0) {
        this.state.listoutlet.map((item)=> {
          if(splitstoredOutletID.indexOf(item._id) >= 0) {
            dipslyOutlet.push(item.label)
          }
        })
      }
      return dipslyOutlet.join(', ');
    }    
  }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"catalog-products"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={this.state.path + "/add"}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Add New
                      </button>
                    </Link>
                  </div>
                </div>

                <div className="row">
                  <div class="card mb-4">
                    <div class="card-body">
                      <div class="form-floating form-floating-outline" id="searchAI">
                        <input
                          type="text"
                          class="form-control"
                          value={this.state.searchKeyWord}
                          placeholder="Ask `AI` to create Voucher"
                          aria-describedby="floatingInputHelp"
                          onChange={(event) => {
                            this.setState({
                              searchKeyWord: event.target.value,
                            });
                          }}
                          onKeyPress={(event) => {
                            if (event.key === "Enter") {
                              this.getAIData();
                            }
                          }}
                        />
                        <label htmlFor="floatingInput">
                          Ask `AI` to create Voucher
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4 pro-filter-row">
                  <div className="col-md-3 pro-filter-text">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        onChange={this.handleChangeText}
                        value={this.state.name}
                      />
                      <label htmlFor="name">Voucher Name</label>
                    </div>
                  </div>

                  <div className="col-md-3 pro-filter-outlet">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.storeID}
                        onChange={this.handleSelectChange.bind(this, "storeID")}
                        placeholder="Select Outlet"
                        isClearable={true}
                        options={this.state.outletList}
                      />
                      <label className="select-box-label">Outlet</label>
                    </div>
                  </div>

                  <div className="col-md-3 pro-filter-search">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.producttype}
                        onChange={this.handleSelectChange.bind(
                          this,
                          "producttype"
                        )}
                        placeholder="Select Type"
                        isClearable={true}
                        options={[
                          { value: "1", label: "Reward Voucher" },
                          { value: "5", label: "Point Voucher" },
                        ]}
                      />
                      <label className="select-box-label">Product Type</label>
                    </div>
                  </div>

                  <div className="col-md-3 pro-filter-search">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.status}
                        onChange={this.handleSelectChange.bind(this, "status")}
                        placeholder="Select Status"
                        isClearable={true}
                        options={[
                          { value: "A", label: "Active" },
                          { value: "I", label: "Inactive" },
                        ]}
                      />
                      <label className="select-box-label">Status</label>
                    </div>
                  </div>

                  <div className="col-md-1 mt-2 pro-filter-sbtbtn">
                    <button
                      type="button"
                      className="btn btn-primary me-sm-3 me-1 waves-effect waves-light"
                      onClick={this.searchList.bind(this)}
                    >
                      Search
                    </button>
                  </div>

                  <div className="col-md-1 mt-2 pro-filter-refbtn">
                    <button
                      type="reset"
                      className="btn btn-label-secondary waves-effect"
                      onClick={this.resetSearch.bind(this)}
                    >
                      Reset
                    </button>
                  </div>
                </div>
                <div className="card">
                  <div className="p-1 mt-4">
                    {parseInt(this.state.totalPage) >0 && showRecords(this.state.currentPage, this.state.totalRecords, moduleName)}
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Actions</th>
                          <th>Voucher Name</th>
                          <th>Alias Name</th>
                          <th>Outlet Name</th>
                          <th>Type Of Product</th>
                          <th>SKU</th>
                          <th>Price</th>
                          <th>Status</th>                          
                        </tr>
                      </thead>
                      <tbody>

                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={7} align="center">
                              <div
                                className="spinner-border spinner-border-lg text-primary"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </td>
                          </tr>
                        ) : this.state.listdata.length > 0 ? (
                          this.state.listdata.map((item, index) => {
                            return (
                              <tr key={index} className={item.productStatus==="I"?'text-danger':''}>
                                 <td>
                                  <div className="dropdown">
                                    <button
                                      type="button"
                                      className="btn p-0 dropdown-toggle hide-arrow"
                                      data-bs-toggle="dropdown"
                                    >
                                      <i className="mdi mdi-dots-horizontal"></i>
                                    </button>
                                    <div className="dropdown-menu">
                                      <Link
                                        to={
                                          this.state.path +
                                          "/edit/" +
                                          encodeValue(item._id)
                                        }
                                        className="dropdown-item"
                                      >
                                        <i className="mdi mdi-pencil-outline me-1"></i>
                                        Edit
                                      </Link>
                                      <a
                                        className="dropdown-item"
                                        href={void 0}
                                        onClick={this.removeItem.bind(
                                          this,
                                          encodeValue(item._id)
                                        )}
                                      >
                                        <i className="mdi mdi-trash-can-outline me-1"></i>
                                        Delete
                                      </a>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <strong>{item.productName}</strong>
                                </td>
                                <td>{item.productAliasName}</td>
                                <td>{this.displayOutlet(item.productOutletID)}</td>
                                <td>{(item.productType===1)?'Reward Voucher':'Point Voucher'}</td>
                                <td>{item.productSKU}</td>
                                <td>{item.productPrice}</td>
                                <td>{showStatus(item.productStatus)}</td>
                               
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={8}>
                              No {moduleName} Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = Array();
  var totalPages = 0;
  var totalRecords = 0;
  var listoutlet = [];
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      listoutlet = state.listdata[0].outlet;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listoutlet:listoutlet,
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
